import { getStyle } from './getStyle';
import { Image, Text, View } from '@react-pdf/renderer';
import * as React from 'react';
import { SectionStyle } from '../../../../helpers/SectionStyle';

const etoolLogo = require('../../../../img/Logo_small.jpg');

export function getHeader(logoURL: string, orientation: string, unternehmen: string, jahr: number, standort?: string): JSX.Element {
    const sectionId: string = typeof SectionStyle.curPrintSectionId === 'number'
        ? SectionStyle.getCurrentId(true)
        : SectionStyle.getCurrentId();
    const logoSection = sectionId ? require(`../../../../img/logo_section_${sectionId}.jpg`) : etoolLogo;

    return (
        <View style={getStyle('header')} fixed>
            {logoURL &&
                <Image src={logoURL} style={getStyle('headerFirma')} />
            }
            <Image src={logoSection} style={getStyle('headerLogo')} />
            <View style={{ display: 'flex', flexDirection: 'column' }}>
                <View style={{ maxWidth: orientation === 'portrait' ? 356 : 592, maxHeight: 32, display: 'flex', flexDirection: 'row' }}>
                    <Text style={getStyle('headerFirmenname')}>{unternehmen || ''}</Text>
                </View>
                <View
                    style={{
                        minWidth: '100%', maxWidth: '100%', maxHeight: 20, marginTop: '5pt', marginBottom: '5pt', display: 'flex',
                        flexDirection: 'row', flexWrap: 'nowrap',
                    }}
                >
                    <Text>Treibhausgasbericht {jahr || ''}</Text>
                    {!!standort && <Text>:&nbsp;</Text>}
                    {!!standort && <Text style={getStyle('headerStandort')}>{standort}</Text>}
                </View>
                <View style={{ minWidth: '100%', maxWidth: '100%', minHeight: 1, maxHeight: 1, borderBottom: '1pt solid #000' }}>
                    <Text>&nbsp;</Text>
                </View>
            </View>
        </View>
    );
}
